// This file was auto-generated by Fern from our API Definition.
export var GatewayPermissions;
(function (GatewayPermissions) {
    GatewayPermissions.Default = {
        Inherit: "inherit",
        Allow: "allow",
        Ask: "ask",
        Deny: "deny",
        AllowReads: "allow_reads",
    };
    let Tools;
    (function (Tools) {
        Tools.Value = {
            Inherit: "inherit",
            Allow: "allow",
            Ask: "ask",
            Deny: "deny",
            AllowReads: "allow_reads",
        };
    })(Tools = GatewayPermissions.Tools || (GatewayPermissions.Tools = {}));
})(GatewayPermissions || (GatewayPermissions = {}));
